import { Component } from '@angular/core';

@Component({
  selector: 'app-mystery-shopper',
  templateUrl: './mystery-shopper.component.html',
  styleUrls: ['./mystery-shopper.component.scss']
})
export class MysteryShopperComponent {
  test:any;
}
